import React from 'react'

import { BuildFlavour } from '../config/flavours/BuildFlavour'
import { BuildConfig } from '../config/BuildConfig'

import './ResponsiveBrandLogo.scss'

export const ResponsiveBrandLogo = (props: { brand: BuildFlavour }) => {
  const { brand } = props
  return (
    <div className="ResponsiveBrandLogo">
      <div
        className="logo"
        style={{
          marginRight: '10px',
          minWidth: brand.logoWidth,
          minHeight: brand.logoHeight,
          backgroundImage: `url(${BuildConfig.brand.logo})`,
        }}
      />
      <div
        className="logo small"
        style={{
          minWidth: brand.squareLogoSize,
          minHeight: brand.squareLogoSize,
          backgroundImage: `url(${brand.logoSmall ?? ''})`,
        }}
      />
    </div>
  )
}